import { render, staticRenderFns } from "./OrganizationsByStatus.vue?vue&type=template&id=2bbf64e4&scoped=true&"
import script from "./OrganizationsByStatus.vue?vue&type=script&lang=js&"
export * from "./OrganizationsByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf64e4",
  null
  
)

export default component.exports